var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDarkRightChevron(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.40029 4.79965C9.70749 4.79965 10.0147 4.91725 10.2487 5.15125L16.2487 11.1513C16.7179 11.6205 16.7179 12.3789 16.2487 12.8481L10.2487 18.8481C9.77949 19.3173 9.02109 19.3173 8.55189 18.8481C8.08269 18.3789 8.08269 17.6205 8.55189 17.1513L13.7035 11.9997L8.55189 6.84805C8.08269 6.37885 8.08269 5.62045 8.55189 5.15125C8.78589 4.91725 9.09309 4.79965 9.40029 4.79965Z",
    fill: "#182027"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkRightChevron);
export default __webpack_public_path__ + "static/media/darkRightChevron.22d15586ede1f6d40e85ac7a50dfcc0b.svg";
export { ForwardRef as ReactComponent };